// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/instance_loading.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ResponseStatus } from "./util/response_status_pb.js";
import { KapiNotification } from "../model/kapi_notification_pb.js";

/**
 * @generated from message knop.ui.v1.api.InstanceListResponse
 */
export class InstanceListResponse extends Message<InstanceListResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: repeated knop.ui.v1.api.InstanceMetadata instances = 2;
   */
  instances: InstanceMetadata[] = [];

  constructor(data?: PartialMessage<InstanceListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.InstanceListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "instances", kind: "message", T: InstanceMetadata, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InstanceListResponse {
    return new InstanceListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InstanceListResponse {
    return new InstanceListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InstanceListResponse {
    return new InstanceListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InstanceListResponse | PlainMessage<InstanceListResponse> | undefined, b: InstanceListResponse | PlainMessage<InstanceListResponse> | undefined): boolean {
    return proto3.util.equals(InstanceListResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.InstanceMetadata
 */
export class InstanceMetadata extends Message<InstanceMetadata> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  /**
   * @generated from field: string location = 2;
   */
  location = "";

  /**
   * @generated from field: google.protobuf.Timestamp scenario_start = 3;
   */
  scenarioStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scenario_end = 4;
   */
  scenarioEnd?: Timestamp;

  constructor(data?: PartialMessage<InstanceMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.InstanceMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "scenario_start", kind: "message", T: Timestamp },
    { no: 4, name: "scenario_end", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InstanceMetadata {
    return new InstanceMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InstanceMetadata {
    return new InstanceMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InstanceMetadata {
    return new InstanceMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: InstanceMetadata | PlainMessage<InstanceMetadata> | undefined, b: InstanceMetadata | PlainMessage<InstanceMetadata> | undefined): boolean {
    return proto3.util.equals(InstanceMetadata, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.ImportKapiInstanceListRequest
 */
export class ImportKapiInstanceListRequest extends Message<ImportKapiInstanceListRequest> {
  /**
   * @generated from field: string location_code = 1;
   */
  locationCode = "";

  constructor(data?: PartialMessage<ImportKapiInstanceListRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ImportKapiInstanceListRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "location_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportKapiInstanceListRequest {
    return new ImportKapiInstanceListRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportKapiInstanceListRequest {
    return new ImportKapiInstanceListRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportKapiInstanceListRequest {
    return new ImportKapiInstanceListRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportKapiInstanceListRequest | PlainMessage<ImportKapiInstanceListRequest> | undefined, b: ImportKapiInstanceListRequest | PlainMessage<ImportKapiInstanceListRequest> | undefined): boolean {
    return proto3.util.equals(ImportKapiInstanceListRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.ImportKapiInstanceListResponse
 */
export class ImportKapiInstanceListResponse extends Message<ImportKapiInstanceListResponse> {
  /**
   * @generated from field: repeated knop.ui.v1.api.KapiInstanceMetadata instances = 1;
   */
  instances: KapiInstanceMetadata[] = [];

  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 2;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<ImportKapiInstanceListResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ImportKapiInstanceListResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instances", kind: "message", T: KapiInstanceMetadata, repeated: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportKapiInstanceListResponse {
    return new ImportKapiInstanceListResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportKapiInstanceListResponse {
    return new ImportKapiInstanceListResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportKapiInstanceListResponse {
    return new ImportKapiInstanceListResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImportKapiInstanceListResponse | PlainMessage<ImportKapiInstanceListResponse> | undefined, b: ImportKapiInstanceListResponse | PlainMessage<ImportKapiInstanceListResponse> | undefined): boolean {
    return proto3.util.equals(ImportKapiInstanceListResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.KapiInstanceMetadata
 */
export class KapiInstanceMetadata extends Message<KapiInstanceMetadata> {
  /**
   * @generated from field: string instance_name = 1;
   */
  instanceName = "";

  /**
   * @generated from field: string location = 2;
   */
  location = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scenario_start = 4;
   */
  scenarioStart?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp scenario_end = 5;
   */
  scenarioEnd?: Timestamp;

  constructor(data?: PartialMessage<KapiInstanceMetadata>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.KapiInstanceMetadata";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "location", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "created_at", kind: "message", T: Timestamp },
    { no: 4, name: "scenario_start", kind: "message", T: Timestamp },
    { no: 5, name: "scenario_end", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KapiInstanceMetadata {
    return new KapiInstanceMetadata().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KapiInstanceMetadata {
    return new KapiInstanceMetadata().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KapiInstanceMetadata {
    return new KapiInstanceMetadata().fromJsonString(jsonString, options);
  }

  static equals(a: KapiInstanceMetadata | PlainMessage<KapiInstanceMetadata> | undefined, b: KapiInstanceMetadata | PlainMessage<KapiInstanceMetadata> | undefined): boolean {
    return proto3.util.equals(KapiInstanceMetadata, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.ImportKapiInstanceByNameRequest
 */
export class ImportKapiInstanceByNameRequest extends Message<ImportKapiInstanceByNameRequest> {
  /**
   * @generated from field: string instance_name = 1;
   */
  instanceName = "";

  constructor(data?: PartialMessage<ImportKapiInstanceByNameRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ImportKapiInstanceByNameRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportKapiInstanceByNameRequest {
    return new ImportKapiInstanceByNameRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportKapiInstanceByNameRequest {
    return new ImportKapiInstanceByNameRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportKapiInstanceByNameRequest {
    return new ImportKapiInstanceByNameRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ImportKapiInstanceByNameRequest | PlainMessage<ImportKapiInstanceByNameRequest> | undefined, b: ImportKapiInstanceByNameRequest | PlainMessage<ImportKapiInstanceByNameRequest> | undefined): boolean {
    return proto3.util.equals(ImportKapiInstanceByNameRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.ImportKapiInstanceByNameResponse
 */
export class ImportKapiInstanceByNameResponse extends Message<ImportKapiInstanceByNameResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: repeated knop.ui.v1.model.KapiNotification notifications = 3;
   */
  notifications: KapiNotification[] = [];

  /**
   * @generated from field: string instance_id = 4;
   */
  instanceId = "";

  /**
   * @generated from field: string correlation_operation_id = 5;
   */
  correlationOperationId = "";

  /**
   * @generated from field: string correlation_parent_id = 6;
   */
  correlationParentId = "";

  /**
   * @generated from field: string correlation_current_id = 7;
   */
  correlationCurrentId = "";

  constructor(data?: PartialMessage<ImportKapiInstanceByNameResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.ImportKapiInstanceByNameResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "notifications", kind: "message", T: KapiNotification, repeated: true },
    { no: 4, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "correlation_operation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "correlation_parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "correlation_current_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ImportKapiInstanceByNameResponse {
    return new ImportKapiInstanceByNameResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ImportKapiInstanceByNameResponse {
    return new ImportKapiInstanceByNameResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ImportKapiInstanceByNameResponse {
    return new ImportKapiInstanceByNameResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ImportKapiInstanceByNameResponse | PlainMessage<ImportKapiInstanceByNameResponse> | undefined, b: ImportKapiInstanceByNameResponse | PlainMessage<ImportKapiInstanceByNameResponse> | undefined): boolean {
    return proto3.util.equals(ImportKapiInstanceByNameResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.CurrentInstance
 */
export class CurrentInstance extends Message<CurrentInstance> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<CurrentInstance>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.CurrentInstance";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CurrentInstance {
    return new CurrentInstance().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CurrentInstance {
    return new CurrentInstance().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CurrentInstance {
    return new CurrentInstance().fromJsonString(jsonString, options);
  }

  static equals(a: CurrentInstance | PlainMessage<CurrentInstance> | undefined, b: CurrentInstance | PlainMessage<CurrentInstance> | undefined): boolean {
    return proto3.util.equals(CurrentInstance, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.OpenInstanceFromFileRequest
 */
export class OpenInstanceFromFileRequest extends Message<OpenInstanceFromFileRequest> {
  /**
   * @generated from field: string base64_data = 1;
   */
  base64Data = "";

  constructor(data?: PartialMessage<OpenInstanceFromFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.OpenInstanceFromFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "base64_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenInstanceFromFileRequest {
    return new OpenInstanceFromFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenInstanceFromFileRequest {
    return new OpenInstanceFromFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenInstanceFromFileRequest {
    return new OpenInstanceFromFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OpenInstanceFromFileRequest | PlainMessage<OpenInstanceFromFileRequest> | undefined, b: OpenInstanceFromFileRequest | PlainMessage<OpenInstanceFromFileRequest> | undefined): boolean {
    return proto3.util.equals(OpenInstanceFromFileRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.OpenInstanceFromFileResponse
 */
export class OpenInstanceFromFileResponse extends Message<OpenInstanceFromFileResponse> {
  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 1;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: string instance_id = 3;
   */
  instanceId = "";

  /**
   * @generated from field: string correlation_operation_id = 4;
   */
  correlationOperationId = "";

  /**
   * @generated from field: string correlation_parent_id = 5;
   */
  correlationParentId = "";

  /**
   * @generated from field: string correlation_current_id = 6;
   */
  correlationCurrentId = "";

  constructor(data?: PartialMessage<OpenInstanceFromFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.OpenInstanceFromFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "correlation_operation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "correlation_parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "correlation_current_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OpenInstanceFromFileResponse {
    return new OpenInstanceFromFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OpenInstanceFromFileResponse {
    return new OpenInstanceFromFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OpenInstanceFromFileResponse {
    return new OpenInstanceFromFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OpenInstanceFromFileResponse | PlainMessage<OpenInstanceFromFileResponse> | undefined, b: OpenInstanceFromFileResponse | PlainMessage<OpenInstanceFromFileResponse> | undefined): boolean {
    return proto3.util.equals(OpenInstanceFromFileResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.DownloadInstanceAsFileRequest
 */
export class DownloadInstanceAsFileRequest extends Message<DownloadInstanceAsFileRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<DownloadInstanceAsFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.DownloadInstanceAsFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadInstanceAsFileRequest {
    return new DownloadInstanceAsFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadInstanceAsFileRequest {
    return new DownloadInstanceAsFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadInstanceAsFileRequest {
    return new DownloadInstanceAsFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadInstanceAsFileRequest | PlainMessage<DownloadInstanceAsFileRequest> | undefined, b: DownloadInstanceAsFileRequest | PlainMessage<DownloadInstanceAsFileRequest> | undefined): boolean {
    return proto3.util.equals(DownloadInstanceAsFileRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.DownloadInstanceAsFileResponse
 */
export class DownloadInstanceAsFileResponse extends Message<DownloadInstanceAsFileResponse> {
  /**
   * @generated from field: string base64_data = 1;
   */
  base64Data = "";

  /**
   * @generated from field: string file_name = 2;
   */
  fileName = "";

  constructor(data?: PartialMessage<DownloadInstanceAsFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.DownloadInstanceAsFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "base64_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadInstanceAsFileResponse {
    return new DownloadInstanceAsFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadInstanceAsFileResponse {
    return new DownloadInstanceAsFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadInstanceAsFileResponse {
    return new DownloadInstanceAsFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadInstanceAsFileResponse | PlainMessage<DownloadInstanceAsFileResponse> | undefined, b: DownloadInstanceAsFileResponse | PlainMessage<DownloadInstanceAsFileResponse> | undefined): boolean {
    return proto3.util.equals(DownloadInstanceAsFileResponse, a, b);
  }
}

